import { render, staticRenderFns } from "./UserAccount.vue?vue&type=template&id=788697a4&"
import script from "./UserAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('788697a4')) {
      api.createRecord('788697a4', component.options)
    } else {
      api.reload('788697a4', component.options)
    }
    module.hot.accept("./UserAccount.vue?vue&type=template&id=788697a4&", function () {
      api.rerender('788697a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account/user/UserAccount.vue"
export default component.exports